import { useState } from "react";
import { motion } from "framer-motion";
import { ImagesSlider } from "../../ui/imageslider";
import ButtonElement from "../Button/Button";
// Hosted with the site (originally hot-linked from Unsplash / Pexels, which contacted those
// services and set their cookies on every visit). See "Image credits" in the README.
import hero1 from "@/assets/images/carousel/hero-1.jpg";
import hero2 from "@/assets/images/carousel/hero-2.jpg";
import hero3 from "@/assets/images/carousel/hero-3.jpg";
import hero4 from "@/assets/images/carousel/hero-4.jpg";

const images = [hero1, hero2, hero3, hero4];

export function Carousel() {
  const [expanded, setExpanded] = useState(false);

  return (
    <motion.div
      layout
      animate={{ height: "auto" }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      className="overflow-hidden"
    >
      <ImagesSlider className="min-h-screen lg:min-h-[40rem] py-16" images={images}>
        <motion.div
          layout
          initial={{ opacity: 0, y: -80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="z-50 flex flex-col justify-center items-center text-white px-4 sm:px-6"
        >
          {/* Title */}
          <motion.h1 className="font-bold text-[clamp(1.5rem,5vw,4rem)] text-center bg-clip-text text-transparent bg-gradient-to-b from-neutral-50 to-neutral-400 py-8">
            We Provide{" "}
            <span className="inline-block bg-gradient-to-tr from-custom-darkblue via-custom-hov to-custom-light font-bold text-transparent bg-clip-text drop-shadow-lg">
              Best Service
            </span>
          </motion.h1>

          {/* Always Visible Content */}
          <div
            style={{
              paddingLeft: "clamp(0.1rem, 2vw, 6rem)",
              paddingRight: "clamp(0.1rem, 2vw, 6rem)",
            }}
            className="text-justify tracking-normal leading-relaxed content-text-size text-white 2xl:px-40 xl:px-35 lg:px-30"
          >
            <p>
              At{" "}
              <span className="inline-block bg-gradient-to-tr from-custom-darkblue via-custom-hov to-custom-light font-bold text-transparent bg-clip-text drop-shadow-lg">
                Sheel Waterproofing
              </span>
              , we specialize in top-tier waterproofing solutions to protect your
              property from water damage. Our expert team is skilled in basement
              waterproofing, foundation repair, and exterior waterproofing.
              Our dedication extends beyond merely providing exceptional waterproofing services; it encompasses a commitment to unparalleled expertise and quality. Recognizing the imminent threat posed by water damage to properties, we prioritize tailored solutions to mitigate its effects.
            </p>
          </div>

          {/* Expandable Content */}
          <motion.div
            layout
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: expanded ? "auto" : 0, opacity: expanded ? 1 : 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
            className=" overflow-hidden text-base sm:text-lg text-justify"
          >
            {expanded && (
              <p
                style={{
                  paddingLeft: "clamp(0.1rem, 2vw, 6rem)",
                  paddingRight: "clamp(0.1rem, 2vw, 6rem)",
                }}
                className="mt-4 text-justify hyphens-auto tracking-normal leading-loose content-text-size text-white 2xl:px-40 xl:px-35 lg:px-30"
              >
                With a specialized team proficient in basement waterproofing, foundation repair, and exterior waterproofing,
                we assure enduring solutions regardless of project scale or complexity. Our ethos revolves around a client-centric approach,
                where understanding your unique requirements forms the cornerstone of our service. Embracing cutting-edge materials and industry innovations,
                we instill confidence in the longevity and efficacy of our solutions, ensuring your investment is safeguarded against water damage. Opting for{" "}
                <span className="inline-block bg-gradient-to-tr from-custom-darkblue via-custom-hov to-custom-light font-bold text-transparent bg-clip-text drop-shadow-lg">
                  Sheel Waterproofing
                </span>{" "}
                signifies choosing a partner committed to surpassing expectations, delivering exceptional outcomes, and fortifying your property
                against the perils of water damage. We take a client-first approach, ensuring that our tailored solutions provide long-lasting protection.
                With the latest industry innovations and premium materials, we guarantee durable results that safeguard your investment from water damage.
                Choosing Sheel Waterproofing means choosing reliability, exceptional service, and lasting protection.
              </p>
            )}
          </motion.div>

          {/* Toggle Button */}
          <ButtonElement
            className="mt-[2rem]"
            btnText={expanded ? "See Less" : "See More"}
            onClick={() => setExpanded(!expanded)}
            size="small"
          />
        </motion.div>
      </ImagesSlider>
    </motion.div>
  );
}
